<template>
  <div v-if="!ratingSelected"
       class="rating-wrapper"
       :class="{ 'pb-6': !isMobile && !showCommentTextArea }"
  >
    <b-col class="rating-col">
      <b-row class="justify-content-center">
        <div v-for="rating in ratingRange"
             :key="rating"
             class="rating-box px-1"
        >
          <b-button
            class="rating-btn"
            :class="[ratingColors(rating), selectedRatingValue === rating ? 'selected' : '']"
            @click="selectRating(rating)"
          >{{ rating }}</b-button>
          <div v-if="rating === lowestRating || rating === highestRating" class="rating-txt mt-2">{{ ratingText(rating) }}</div>
        </div>
      </b-row>
      <b-row v-if="showCommentTextArea" class="comment-wrapper justify-content-start">
        <STextarea
          v-model="feedbackMessage"
          :label-text="$t('classbook.feedback_survey.comment_feedback_title')"
          spellcheck="true"
          class="w-100"
          data-cy="feedback-message"
          name="entry.feedback.message"
          :placeholder="$t('classbook.feedback_survey.comment_feedback_placeholder')"
          :rows="4"
          :max-height="186"
        />
      </b-row>
    </b-col>
    <SModalPortalTo>
      <b-button v-if="showCommentTextArea"
                variant="primary"
                block
                @click.prevent="sendFeedBack"
      >
        {{ $t('classbook.feedback_survey.send_feedback') }}
      </b-button>
    </SModalPortalTo>
  </div>
  <div v-else>
    <p class="rating-title text-center mb-3">{{ $t('classbook.feedback_survey.title_thank_you') }}</p>
    <p class="sub-title text-center">{{ $t('classbook.feedback_survey.subtitle') }}</p>
    <div class="text-center">
      <img src="/img/miscellaneous/ui/heart.svg"
           alt=""
           height="100"
           class="mb-4"
           loading="lazy"
      />
    </div>
  </div>
</template>

<script>
import IsMobileDeviceMixin from 'src/mixins/miscellaneous/isMobileDeviceMixin.js'
import { User } from 'src/store/models/index.js'
import SModalPortalTo from 'src/components/base/SModal/SModalPortalTo.vue'

export default {
  name: 'FeedbackSurveyModal',
  components: { SModalPortalTo },
  mixins: [IsMobileDeviceMixin],
  props: {
    surveyType: {
      type: String,
      default: 'sdui_general',
    },

    ratingRange: {
      type: Array,
      default: () => [1, 2, 3, 4, 5],
    },
  },

  data: () => ({
    ratingSelected: false,
    selectedRatingValue: null,
    feedbackMessage: '',
  }),

  computed: {
    highestRating() {
      return this.ratingRange[this.ratingRange.length - 1]
    },

    lowestRating() {
      return this.ratingRange[0]
    },

    showCommentTextArea() {
      return this.selectedRatingValue < 4 && this.selectedRatingValue > 0
    },
  },

  methods: {
    ratingText(rating) {
      if (this.highestRating === rating) return this.$t('classbook.feedback_survey.very_satisfied')
      if (this.lowestRating === rating) return this.$t('classbook.feedback_survey.very_unsatisfied')
    },

    ratingColors(rating) {
      if (rating === 1 || rating === 2) return 'low-rating'
      if (rating === 4 || rating === 5) return 'high-rating'
      return 'neutral-rating'
    },

    async sendFeedBack(ratingSelected = true) {
      await User.updateProps({
        [`users.surveys.${this.surveyType}.feedback`]: this.feedbackMessage,
        [`users.surveys.${this.surveyType}.hidden`]: true,
        [`users.surveys.${this.surveyType}.result`]: this.selectedRatingValue,
      })
      this.ratingSelected = ratingSelected
    },

    async selectRating(rating) {
      this.selectedRatingValue = Number(rating)
      await this.sendFeedBack(rating > 3)
    },
  },
}
</script>

<style scoped lang="scss">
.rating-title {
  font-size: pxtorem(17);
}

.sub-title {
  font-size: pxtorem(15);
  font-weight: 450;
  color: $color-gray-300;
}

.rating-col {
  .rating-box {
    max-width: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .rating-txt {
    font-size: pxtorem(11);
    max-width: 70px;
    min-width: 60px;
    text-align: center;
  }
  .rating-btn {
    border: 0;
    height: 52px;
    width: 52px;
    border-radius: 12px;
    &.low-rating {
      background-color: $color-danger-light;
      color: $color-danger;
      &.selected {
        border: 2px solid $color-danger;
      }
    }
    &.neutral-rating {
      background-color: $color-warning-light;
      color: $color-warning;
      &.selected {
        border: 2px solid $color-warning;
      }
    }
    &.high-rating {
      background-color: $color-success-light;
      color: $color-success;
    }
  }
  .comment-wrapper {
    padding: 32px 50px 20px 50px;
  }
}
</style>
